// extracted by mini-css-extract-plugin
export default {"apple-auth-btn":"ButtonAppleAuth_apple-auth-btn__xcCux","apple-icon":"ButtonAppleAuth_apple-icon__yw5Kg"};